<template>
  <div class="main game">
    <Header />

    <keep-alive>
      <component :is="currentTabComponent"></component>
    </keep-alive>

    <transition name="navUp">
      <NavBar @click="nav" v-if="$store.state.showNavBar" />
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import NavBar from "@/components/NavBar.vue";
import TabProduction from "@/components/TabProduction.vue";
import TabMedicine from "@/components/TabMedicine.vue";

export default {
  name: "Home",
  components: { Header, NavBar, TabProduction, TabMedicine },
  data() {
    return {
      currentTabComponent: "TabProduction",
      showQA: false,
      mounted: false,
    };
  },

  computed: {
    timeMulti: function() {
      return this.$store.state.timeMulti;
    },

    money: function() {
      return this.$store.state.money;
    },

    tutStep: function() {
      return this.$store.state.tutStep;
    },
  },

  methods: {
    nav: function(string) {
      switch (string) {
        case "Prod":
          this.currentTabComponent = "TabProduction";
          break;

        case "Med":
          this.currentTabComponent = "TabMedicine";
          break;
      }
    },

    visibilityChange: function() {
      if (
        document.visibilityState !== "visible" &&
        this.$store.state.autoPause
      ) {
        this.$store.commit("stopTick");
        this.track("Visibility", "PAUSE");
      }
    },

    removeEventListener: function() {},
  },

  unmounted: function() {
    this.$store.commit("stopTick");
    document.removeEventListener("visibilitychange", this.visibilityChange);
  },

  mounted: function() {
    if (this.$store.state.time > 0) {
      this.$store.commit("stopTick");
    } else {
      this.$store.commit("startTick");
    }

    // loading items
    setTimeout(() => {
      if (this.$store.getters.prodItemsCount < 1) {
        this.$store.dispatch("loadProdItem", 0);
        this.$store.dispatch("loadProdItem", 1);
      }
    }, 1);

    document.addEventListener("visibilitychange", this.visibilityChange);
  },

  watch: {
    timeMulti: function() {
      this.$store.commit("stopTick");
      this.$store.commit("startTick");
    },

    money: function(val) {
      if (val > 500) {
        this.$store.commit("showNavBar");
      }
    },

    //     tutStep: function(val) {
    // ё    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/index.scss";
.game {
  background: $gray100;
  padding-bottom: 120px;
}
</style>
